<template>
  <span class="selection-price">
    <span class="price" :class="{priceUp:priceUp, priceDown:priceDown}">{{formatedOdds || na || ''}}</span>
  </span>
</template>

<script>
import priceFormat from '@/library/priceFormat'

export default {
  name: 'PopularParlayOdds',
  props: [
    'potentialReturn', 'isSGP', 'na'
  ],
  data () {
    return {
      priceUp: false,
      priceDown: false,
      clearInterval: 3,
      clearInt: null
    }
  },
  computed: {
    formatedOdds  () {
      let odds = this.potentialReturn
      return odds ? priceFormat.formatOdds(odds) : ''
    },
    oddsObj () {
      return {
        potentialReturn: this.potentialReturn,
        formatedOdds: this.formatedOdds
      }
    }
  },
  methods: {
    formatOdds (odds) {
      return priceFormat.formatOdds(odds)
    },
    clearMarkings () {
      this.priceUp = false
      this.priceDown = false
    }
  },
  watch: {
    oddsObj: {
      immediate: false,
      handler (newValObj, oldValObj) {
        // console.log('Watch oddsObj:', oldValObj, '=>', newValObj)
        clearTimeout(this.clearInt)
        this.clearInt = setTimeout(() => {
          this.clearMarkings()
        }, this.clearInterval * 1000)
        //
        let priceUp = false
        let priceDown = false
        oldValObj = oldValObj || {}
        newValObj = newValObj || {}
        if (newValObj.formatedOdds !== oldValObj.formatedOdds) {
          let newVal = newValObj && newValObj.potentialReturn
          let oldVal = oldValObj && oldValObj.potentialReturn
          priceUp = newVal > oldVal
          priceDown = newVal < oldVal
        }
        this.priceUp = priceUp
        this.priceDown = priceDown
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/css/config"

.selection-price
  .price.priceUp
    &:before
      background: transparent
      content: url(icons-path'/price-up-small.svg');
      line-height: 0;
      left: -11px;
      top: 4px;
      width: 10px;
      height: 10px;

  .price.priceDown
    &:before
      background: transparent
      content: url(icons-path'/price-down-small.svg');
      line-height: 0;
      left: -11px;
      top: 4px;
      width: 10px;
      height: 10px;
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/popularParlays/PopularParlayOdds.vue